export default __webpack_public_path__ + "static/media/015-fighter-plane.db600bd0.png";